import {
  arsl_addRow,
  arsl_addVariablesToColumn,
  arsl_alignText,
  arsl_applyDroppedColumns,
  arsl_applyDroppedSortColumns,
  arsl_cellUpdate,
  arsl_changeSent,
  arsl_columnUpdate,
  arsl_loadData,
  arsl_removeColumn,
  arsl_removeRow,
  arsl_setColumns,
  arsl_setRowHeight,
  arsl_setTlfViewMode,
  arsl_setVariableFilter,
  arsl_setViewColumnPropertiesId,
  arsl_updateScaffold,
} from "./functions";
import { arsl_addBlankColumn } from "./functions/arsl_addBlankColumn";
import {
  ARSL_ADD_BLANK_COLUMN,
  ARSL_ADD_ROW,
  ARSL_ADD_VARIABLES_TO_COLUMN,
  ARSL_ALIGN_TEXT,
  ARSL_APPLY_DROPPED_COLUMNS,
  ARSL_APPLY_DROPPED_SORT_COLUMNS,
  ARSL_CELL_UPDATE,
  ARSL_CHANGE_SENT,
  ARSL_COLUMN_UPDATE,
  ARSL_LOAD_DATA,
  ARSL_REMOVE_COLUMN,
  ARSL_REMOVE_ROW,
  ARSL_SET_COLUMNS,
  ARSL_SET_ROW_HEIGHT,
  ARSL_SET_TLF_VIEW_MODE,
  ARSL_SET_VARIABLE_FILTER,
  ARSL_SET_VIEW_COLUMN_PROPERTIES_ID,
  ARSL_UPDATE_SCAFFOLD,
  ArsListingAction,
  ArsListingState,
} from "./interface";

/**
 * ARS Listing reducer function
 *
 * @param state - Current ArsListingState
 * @param action - Action to perform on the state
 * @returns Updated ArsListingState
 */
export const arsListingReducer = <T>(
  state: ArsListingState<T>,
  action: ArsListingAction<T>,
): ArsListingState<T> => {
  switch (action.operation) {
    case ARSL_ADD_BLANK_COLUMN:
      return arsl_addBlankColumn(state, action);

    case ARSL_ADD_ROW:
      return arsl_addRow(state, action);

    case ARSL_ADD_VARIABLES_TO_COLUMN:
      return arsl_addVariablesToColumn(state, action);

    case ARSL_ALIGN_TEXT:
      return arsl_alignText(state, action);

    case ARSL_APPLY_DROPPED_COLUMNS:
      return arsl_applyDroppedColumns(state, action);

    case ARSL_APPLY_DROPPED_SORT_COLUMNS:
      return arsl_applyDroppedSortColumns(state, action);

    case ARSL_CELL_UPDATE:
      return arsl_cellUpdate(state, action);

    case ARSL_CHANGE_SENT:
      return arsl_changeSent(state);

    case ARSL_COLUMN_UPDATE:
      return arsl_columnUpdate(state, action);

    case ARSL_LOAD_DATA:
      return arsl_loadData(state, action);

    case ARSL_REMOVE_COLUMN:
      return arsl_removeColumn(state, action);

    case ARSL_REMOVE_ROW:
      return arsl_removeRow(state, action);

    case ARSL_SET_COLUMNS:
      return arsl_setColumns(state, action);

    case ARSL_SET_ROW_HEIGHT:
      return arsl_setRowHeight(state, action);

    case ARSL_SET_TLF_VIEW_MODE:
      return arsl_setTlfViewMode(state, action);

    case ARSL_SET_VARIABLE_FILTER:
      return arsl_setVariableFilter(state, action);

    case ARSL_SET_VIEW_COLUMN_PROPERTIES_ID:
      return arsl_setViewColumnPropertiesId(state, action);

    case ARSL_UPDATE_SCAFFOLD:
      return arsl_updateScaffold(state, action);
  }
};
